module.exports = __webpack_public_path__ + "site/img/265.716054ec.jpg";